import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ParentSize } from "@visx/responsive";
import { ApplicationState } from '../../../reducers/Index';
import { loadEarlyCareerReport, loadEarlyCareerSharedReport, loadEarlyCareerReportCounts } from '../../../actions/EarlyCareerReportActions';
import { UserEarlyCareerReportState, EarlyCareerReportAction } from '../../../interface/EarlyCareerReportInterface';
import ViewReportModal from '../ViewReportModal';
import EarlyCareerReportMenu from './EarlyCareerReportRightMenu';
import AwardCountChart from './AwardCountChart';
import AuthorshipChart from './AuthorshipChart';
import PublicationChart from './PublicationChart';
import POEChart from './POEChart';
import GrantDollarsChart from './GrantDollarsChart';
import TeamCompositionChart from './TeamCompositionChart';
import JournalRankChart from './JournalRankChart';
import EarlyCareerReportSankey from './EarlyCareerReportSankey';
// track user visit
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { Heading1, Heading2, Heading3, IRISLightGreyDivider, ReportText, TextLink, TextSpan } from '../../Common/SharedStyledComponents';
import styled, { css } from "styled-components";
import { Col, Row } from 'react-bootstrap';
import { IrisColors } from '../../../css/IRISColors';
import LoadingSpinner from '../../Common/LoadingSpinner';
import "./EarlyCareerReport.css";
import { HashLink as Link } from 'react-router-hash-link';
import EarlyCareerReportFilterMenu from './EarlyCareerReportFilterMenu';

interface EarlyCareerReportState {
    currentDateTime?: any;
}

class EarlyCareerReport extends React.Component<EarlyCareerReportAction & UserEarlyCareerReportState & RouteComponentProps<{}>, EarlyCareerReportState> {
    constructor(props) {
        super(props);

        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        this.state = {
            currentDateTime: currentDate,
        };
    }

    reportHeight = 0;

    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {

            this.props.loadEarlyCareerSharedReport(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"]);

        } else {
            let filterSavedValues = this.props.EarlyCareerReportState && this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues;
            if (filterSavedValues == undefined) {
                filterSavedValues = {
                    ecr_award: [],
                    gender: [],
                    suborg: [],
                    funder: [],
                    no_compare: true,
                    ecr_award_compare: false,
                    gender_compare: false
                };
            }

            let selections = this.props.EarlyCareerReportState?.EarlyCareerReportFilterSelection;
            if (selections == undefined) {
                selections = {
                    checked_1: false,
                    checked_0: false,
                    checked_M: false,
                    checked_F: false,
                    checked_U: false,
                    checked_suborg1: false,
                    checked_suborg2: false,
                    checked_suborg3: false,
                    checked_suborg4: false,
                    checked_suborg5: false,
                    checked_NIH: false,
                    checked_NSF: false,
                    checked_nonfed: false,
                    checked_otherfunder: false,

                    checked_no_compare: true,
                    checked_ecr_award_compare: false,
                    checked_gender_compare: false
                }
            }
            
            this.props.loadEarlyCareerReport(
                this.props.UserState.report_display_id,
                this.props.UserState.report_university_name,
                filterSavedValues,
                selections,
                this.props.UserState.report_vintage_early_career
            );

            this.props.loadEarlyCareerReportCounts(this.props.UserState.report_display_id, filterSavedValues, this.props.UserState.report_vintage_early_career);
        }

        const height = document.querySelector("#report-col");
        this.reportHeight = height ? height.scrollHeight + 1100 : 0
    }

    componentDidUpdate(prevProps) {
       
    }
    
    public render() {
        let logoUni;
        try {
            logoUni = require(`../../../images/univ_logos/${this.props.UserState.report_display_id}.png`);
        }
        catch (err) {

        }
        if (this.props.EarlyCareerReportState?.EarlyCareerReportFilterSavedValues == undefined) {
            return <LoadingSpinner loadingText="Loading Report Data..." />
        }

        const { no_compare, ecr_award_compare, gender_compare } = this.props.EarlyCareerReportState?.EarlyCareerReportFilterSavedValues;
        const { EarlyCareerReportBasicInfo, Suborgs, EarlyCareerReportFilterCounts, SankeyData, EarlyCareerReportAwardCount, EarlyCareerReportAwardCount_2, GrantData, GrantData_2, TeamData, TeamData_2, POEData, POEData_2 } = this.props.EarlyCareerReportState;
        
        if (
                ((no_compare && (!EarlyCareerReportBasicInfo || !Suborgs || !EarlyCareerReportFilterCounts || !SankeyData || !EarlyCareerReportAwardCount || !GrantData || !TeamData || !POEData)) ||
                ((ecr_award_compare || gender_compare) && (!SankeyData || !EarlyCareerReportAwardCount || !GrantData || !TeamData || !POEData || !EarlyCareerReportAwardCount_2 || !GrantData_2 || !TeamData_2 || !POEData_2)))
            )
            return <LoadingSpinner loadingText="Loading Report Data..." />
      
        var loadSharedLink = false;

        const university = this.props.EarlyCareerReportState?.EarlyCareerReportBasicInfo.university;

        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            loadSharedLink = true;

        }
        const start_year = EarlyCareerReportBasicInfo && EarlyCareerReportBasicInfo.start_year, end_year = EarlyCareerReportBasicInfo && EarlyCareerReportBasicInfo.end_year;
        return (
            <ReportContainer className="ecr_report">
                {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"EarlyCareerReport"} /> : null}
                <Row>
                    <Col lg={9} md={9} id="report-col" style={{ padding: 0 }} >
                        <EarlyCareerReportFilterMenu />
                        <ReportContent id="report-content">
                            <Heading1 bold id="summary">Early Career Researcher Report</Heading1>
                            <ReportText>
                                This report tracks researchers’ paths toward funding independence, as measured by grant awards, percentage of effort devoted to grant-funded work, and research team size. Comparisons can be made by gender and early-career award status.
                            </ReportText>
                            <ReportText>
                                <strong>A NOTE ON THE DATA:</strong> This report divides data into cohorts based on faculty members’ appearance in the IRIS-UMETRICS dataset, which contains information on research employment on funded grants.
                            </ReportText>
                            <ReportText>
                                “Data Year 1,” for example, consists of all faculty members during the first year they are observed in the dataset, regardless of the calendar year. “Data Year 2” contains all faculty members observed for two years in the dataset, and so on. <Link to="/reports/early-career-report/#population">Click here</Link> for a visualization of the population of researchers contained in each cohort. Data from {this.props.EarlyCareerReportState?.EarlyCareerReportBasicInfo?.start_year} to {this.props.EarlyCareerReportState?.EarlyCareerReportBasicInfo?.end_year} were used to build these cohorts.
                            </ReportText>
                            <ReportText>
                                Inclusion in the IRIS-UMETRICS dataset directly corresponds with the number of years a faculty researcher has received sponsored grant funding while at your university. Therefore, the “Data Year” cohorts can effectively measure faculty members’ progression toward funding independence as reflected in their number of grants, total amount of grant funding, and percentage of effort devoted to grant-funded projects.
                            </ReportText>

                            <Heading3 bold>How to use the report</Heading3>
                            <ReportText>
                                Using the filter and comparison selections, the data can be filtered by researchers' academic unit, primary funding source, gender, and whether they have received early career awards from NSF, NIH, or DOD.
                            </ReportText>
                            <div id="chart1" className="chartimage">
                                <AwardCountChart
                                    awardCount={this.props.EarlyCareerReportState.EarlyCareerReportAwardCount}
                                    awardCount_2={this.props.EarlyCareerReportState.EarlyCareerReportAwardCount_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="chart2" className="chartimage">
                                <GrantDollarsChart
                                    grantData={this.props.EarlyCareerReportState.GrantData}
                                    grantData_2={this.props.EarlyCareerReportState.GrantData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="chart3" className="chartimage">
                                <TeamCompositionChart
                                    teamData={this.props.EarlyCareerReportState.TeamData}
                                    teamData_2={this.props.EarlyCareerReportState.TeamData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="chart4" className="chartimage">
                                <POEChart
                                    poeData={this.props.EarlyCareerReportState.POEData}
                                    poeData_2={this.props.EarlyCareerReportState.POEData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />                                
                            </div>
                            <div id="chart5" className="chartimage">
                                <PublicationChart
                                    pubData={this.props.EarlyCareerReportState.PubData}
                                    pubData_2={this.props.EarlyCareerReportState.PubData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="chart6" className="chartimage">
                                <AuthorshipChart
                                    authorData={this.props.EarlyCareerReportState.AuthorData}
                                    authorData_2={this.props.EarlyCareerReportState.AuthorData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="chart7" className="chartimage">
                                <JournalRankChart
                                    journalRankData={this.props.EarlyCareerReportState.JournalRankData}
                                    journalRankData_2={this.props.EarlyCareerReportState.JournalRankData_2}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                            <div id="population"></div>
                            <div style={{ height: "10px", minHeight: "10px", clear: "both" }}></div>
                            
                            <div id="chart8" className="chartimage">
                                <EarlyCareerReportSankey
                                    sankeyData={this.props.EarlyCareerReportState.SankeyData}
                                    EarlyCareerReportState={this.props.EarlyCareerReportState}
                                    report_display_id={this.props.UserState.report_display_id}
                                    currentDateTime={this.state.currentDateTime}
                                    parentWidth={900}
                                    university={university}
                                    start_year={start_year}
                                    end_year={end_year}
                                    vintage={this.props.UserState.report_vintage_early_career}
                                />
                            </div>
                        </ReportContent>
                    </Col>
                    {(!sharedLinkPageOnLoad || (sharedLinkPageOnLoad &&
                        this.props.UserState.sharedLinkEmailSubmitted)) &&
                        <Col lg={3} md={3} style={{ height: "1000px" }}>
                    <EarlyCareerReportMenu />
                    </Col>
                }
                </Row>
            </ReportContainer>
        );
    }
}

export const ReportContainer = styled.div`
    max-width: max(100%, 1240px);
    padding-top: 10px;
    margin-inline: auto 0;
`;

export const ReportContent = styled.article`
    position: relative;
    padding: 15px;
    border-radius: 0px;
    background: white;
    min-height: 1500px;
    border: solid 1px #D3D3D3;
`;



const DestinationsList = styled.div`
    column-count: 4;
`;

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadEarlyCareerReport: loadEarlyCareerReport,
            loadEarlyCareerSharedReport: loadEarlyCareerSharedReport,
            loadEarlyCareerReportCounts: loadEarlyCareerReportCounts
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(EarlyCareerReport, "Early Career Report", "landing page"));

